import React from 'react';
import { Grid as MuiGrid } from '@mui/material';

export type GridItemsAlignment = 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline';
export type GridContentAlignment = 'stretch' | 'center' | 'flex-start' | 'flex-end' | 'space-between' | 'space-around';
export type GridDirection = 'row' | 'row-reverse' | 'column' | 'column-reverse';
export type GridSpacing = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10;

export type GridJustification =
  | 'flex-start'
  | 'center'
  | 'flex-end'
  | 'space-between'
  | 'space-around'
  | 'space-evenly';

export type GridWrap = 'nowrap' | 'wrap' | 'wrap-reverse';
export type GridSize = 'auto' | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

export interface GridProps {
  className?: string;
  style?: React.CSSProperties;
  alignContent?: GridContentAlignment;
  alignItems?: GridItemsAlignment;
  children?: React.ReactNode;
  container?: boolean;
  direction?: GridDirection;
  item?: boolean;
  /**
   * v4's name for `justifyContent`, removed in v5. Kept and remapped below so the 68
   * `justify=` call sites across 35 files need no edit; prefer `justifyContent` in new code.
   */
  justify?: GridJustification;
  justifyContent?: GridJustification;
  spacing?: GridSpacing;
  wrap?: GridWrap;
  zeroMinWidth?: boolean;
  xs?: boolean | GridSize | undefined;
  sm?: boolean | GridSize | undefined;
  md?: boolean | GridSize | undefined;
  lg?: boolean | GridSize | undefined;
  xl?: boolean | GridSize | undefined;
  component?: React.ElementType | undefined;
  innerRef?: React.Ref<HTMLDivElement> | undefined;
}

const Grid: React.FC<GridProps> = ({ innerRef, children, justify, justifyContent, ...gridProps }) => {
  return (
    // An explicit `justifyContent` wins over the legacy `justify`; no call site passes both.
    <MuiGrid ref={innerRef} justifyContent={justifyContent ?? justify} {...gridProps}>
      {children}
    </MuiGrid>
  );
};

export default Grid;
